export default __webpack_public_path__ + "static/media/char_head_010.50784c40.png";